import { cn } from "@/util/functions";

const EventButton = ({
  text,
  className = "",
  onChangeEvent,
  color = "primary",
  children,
  ...otherProps
}) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  return (
    <button
      className={cn(
        "tw-py-1 tw-px-2 tw-font-medium tw-text-sm tw-text-white tw-rounded-md tw-border-none",
        `tw-bg-event-${color} hover:tw-bg-event-${color}-hover`,
        "disabled:tw-bg-gray-400 disabled:tw-cursor-not-allowed",
        className
      )}
      onClick={onChangeEvent}
      onKeyDown={handleKeyDown}
      {...otherProps}
    >
      {children ?? text}
    </button>
  );
};

export default EventButton;
